import { Link } from "react-router-dom";

const TransportationPlanningForWeddingsAndSpecialEvents = () => {
    return (
        <section className="bg-primary">
            <div className="max-w-7xl mx-auto px-4">
                <div className="py-20 md:py-28">

                    <div className="text-center">

                        <p className="text-white/70 text-sm uppercase tracking-widest">
                            Events
                        </p>

                        <h1 className="mt-4 text-white text-4xl md:text-6xl font-bold max-w-5xl mx-auto leading-tight">
                            Transportation Planning For Weddings And Special Events
                        </h1>

                        <div className="mt-8 flex flex-wrap justify-center gap-4 text-white/70">
                            <span>May 22, 2026</span>
                            <span>•</span>
                            <span>Velox Charter</span>
                        </div>

                    </div>

                </div>
            </div>

            <section className="bg-[#F9FAFB] py-16 lg:py-24">
                <div className="max-w-7xl mx-auto px-4">

                    <div className="grid lg:grid-cols-12 gap-10">
                        <div className="lg:col-span-8">

                            <div className="bg-white rounded-[30px] overflow-hidden shadow-sm">

                                <img
                                    src="/images/veloxcharter-wedding-events.png"
                                    alt="Wedding Transportation"
                                    className="w-full h-[300px] md:h-[500px] object-cover"
                                />

                                <div className="p-8 md:p-12">
                                    <p className="text-[#666666] leading-8 text-lg">
                                        Weddings and special events require
                                        careful planning, attention to detail,
                                        and flawless coordination. While venue
                                        selection, catering, and entertainment
                                        often receive the most attention,
                                        transportation planning is equally
                                        important to ensure guests arrive
                                        comfortably, safely, and on time.
                                    </p>

                                    <p className="mt-6 text-[#666666] leading-8 text-lg">
                                        Professional transportation services
                                        help simplify event logistics while
                                        creating a more enjoyable experience
                                        for everyone involved.
                                    </p>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            1. Start Planning Early
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Transportation should be included
                                            in your event planning process from
                                            the beginning. Booking early gives
                                            you access to more vehicle options
                                            and helps avoid last-minute
                                            availability issues.
                                        </p>

                                        <ul className="mt-5 space-y-3 text-[#666666]">
                                            <li>✓ Secure Preferred Vehicles</li>
                                            <li>✓ Better Scheduling Options</li>
                                            <li>✓ Simplified Event Coordination</li>
                                            <li>✓ Reduced Planning Stress</li>
                                        </ul>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            2. Determine Guest Transportation Needs
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Consider how many guests require
                                            transportation and whether they
                                            will be traveling between multiple
                                            locations during the event.
                                        </p>

                                        <div className="grid sm:grid-cols-2 gap-4 mt-6">
                                            {[
                                                "Hotel To Venue",
                                                "Venue To Reception",
                                                "Airport Transfers",
                                                "Guest Shuttle Services",
                                            ].map((item, index) => (
                                                <div
                                                    key={index}
                                                    className="bg-[#F8FAFC] border rounded-[16px] p-5"
                                                >
                                                    {item}
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            3. Select The Right Vehicle
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Choosing the appropriate vehicle
                                            depends on group size, event style,
                                            travel distance, and guest comfort.
                                        </p>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Luxury SUVs and Sprinter Vans are
                                            ideal for wedding parties and VIP
                                            guests, while charter buses and
                                            mini coaches are excellent for
                                            transporting larger groups.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            4. Improve Guest Experience
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Providing transportation for guests
                                            eliminates concerns about parking,
                                            traffic, navigation, and designated
                                            drivers. This allows guests to relax
                                            and focus on enjoying the event.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            5. Enhance Safety
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Safety should always be a priority,
                                            particularly during weddings,
                                            celebrations, and evening events.
                                            Professional transportation services
                                            provide safe and dependable travel
                                            for guests throughout the event.
                                        </p>

                                        <ul className="mt-5 space-y-3 text-[#666666]">
                                            <li>✓ Professional Drivers</li>
                                            <li>✓ Safe Transportation Routes</li>
                                            <li>✓ Reliable Scheduling</li>
                                            <li>✓ Reduced Parking Risks</li>
                                        </ul>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            6. Coordinate Multiple Locations
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Many weddings and events involve
                                            multiple venues. Transportation
                                            services help coordinate guest
                                            movement between hotels, ceremony
                                            sites, reception venues, and
                                            after-party locations.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            7. Work With Experienced Transportation Professionals
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Partnering with an experienced
                                            transportation company ensures every
                                            detail is handled professionally.
                                            From route planning to scheduling,
                                            transportation specialists help
                                            create a seamless experience for
                                            organizers and guests alike.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            Final Thoughts
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Transportation planning is an
                                            essential part of any successful
                                            wedding or special event. By
                                            organizing transportation in
                                            advance, selecting the right
                                            vehicles, and prioritizing guest
                                            comfort and safety, you can create
                                            a smooth and memorable experience
                                            for everyone involved.
                                        </p>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Whether you're planning an intimate
                                            wedding, a large celebration, a
                                            corporate gala, or a private event,
                                            professional transportation services
                                            can help ensure every guest arrives
                                            comfortably and on time.
                                        </p>
                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className="lg:col-span-4">

                            <div className="sticky top-6">

                                <div className="bg-primary rounded-[24px] p-8 text-center">

                                    <h3 className="text-white text-2xl font-semibold">
                                        Planning A Wedding Or Special Event?
                                    </h3>

                                    <p className="mt-4 text-white/80 leading-7">
                                        Let our transportation specialists help
                                        you coordinate comfortable, reliable,
                                        and professional transportation for
                                        your guests.
                                    </p>

                                    <Link
                                        to="/contact-us"
                                        className="mt-4 inline-block bg-white text-primary px-8 py-4 rounded-full font-semibold hover:scale-105 transition-all"
                                    >
                                        Contact Us
                                    </Link>

                                </div>

                                <div className="bg-white rounded-[24px] p-8 mt-8">

                                    <h3 className="text-2xl font-semibold">
                                        Event Planning Checklist
                                    </h3>

                                    <div className="mt-6 space-y-4 text-[#666666]">

                                        <p>✓ Confirm Guest Count</p>
                                        <p>✓ Select Transportation Vehicles</p>
                                        <p>✓ Finalize Pickup Locations</p>
                                        <p>✓ Coordinate Event Timeline</p>
                                        <p>✓ Book Transportation Early</p>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </section>

        </section>
    );
};

export default TransportationPlanningForWeddingsAndSpecialEvents;